import React, { useState, useRef } from 'react';

function Accessibility(prop) {

    const [content, setContent] = useState('');

    

    if (content == '') {

        if (prop.lang == 'en') {
            setContent('Jump to the content zone at the center');
        }
        if (prop.lang == 'tw') {
            setContent('跳到主要內容區塊');
        }

    } else {

        return (<div className="for_accessibility">

            <a href="#mainContent" className="" tabIndex="1" title={content} >{content}</a>
            <div></div>

        </div>);
    }
}

export default Accessibility;